import React, { type ReactNode } from "react";
import classNames from "classnames";
import "./styles.scss";

/** Surfaces that share palette with `InnerPanel` variants (pill styling). */
export type BadgeVariant =
  | "grey"
  | "darkGrey"
  | "white"
  | "alert"
  | "alertWhite"
  | "note"
  | "inset"
  | "appointment"
  | "warning"
  | "successFill"
  | "successSolid"
  | "success"
  | "tertiary"
  | "tertiaryCompact"
  | "caseSection";

export type BadgeProps = {
  children: ReactNode;
  variant: BadgeVariant;
  className?: string;
};

export default function Badge({ children, variant, className }: BadgeProps) {
  return <span className={classNames("badge", `badge--${variant}`, className)}>{children}</span>;
}
